import { EventsDesktopView } from './EventsDesktopView';

export function EventsTabletView() {
  return <EventsDesktopView />;
}
